export const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL || "http://localhost:4000";
export const DISCOUNT_CODE = "897WGP9E0GDY";
